<template>
  <div>
    <img src="/static/img/assets/logo/MetaPay.png" style="max-width: 200px; width: 100%" alt />
    <div class="mt-3">
      {{
        $t(
          "A payment process via Messenger, which connects to renowned banks' application, offers your customers a convenient purchases without attaching the receipt."
        )
      }}
      <a
        href="https://blog.zwiz.app/metapay-registration/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t('How to use') }}?
      </a>
      <span> {{ $t('or') }} </span>
      <a
        href="https://business.facebook.com/latest/orders/payment_settings"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t('Register Meta Pay') }}
      </a>
    </div>

    <v-layout wrap>
      <v-flex xs12 v-if="fbpayStatus == null">
        <v-dialog v-model="fb_pay_dialog" width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" color="primary" depressed class="mx-0">{{
              $t('Turn on/off Meta Pay')
            }}</v-btn>
          </template>

          <v-card>
            <v-card-title class="text-h5 lighten-2">
              <h3>Meta Pay</h3>
            </v-card-title>
            <v-card-text>
              {{ $t('fb_pay_dialog') }}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="toggleStatus" color="primary" depressed class="mx-0">{{
                $t('accept')
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <template v-else>
        <v-flex xs12 sm6>{{ $t('Turn on/off Meta Pay') }}</v-flex>
        <v-flex xs12 sm6 class="text-xs-left text-sm-right">
          <toggle-button
            class="mt-2"
            :value="fbpayStatus"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="toggleStatus"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
          />
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      fb_pay_dialog: false,
      fbpayStatus: null,
      loading: false
    }
  },
  mounted() {
    this.fbpayStatus = this.selectedBot.fbpay_status
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      currentLang: 'currentLang'
    })
  },
  methods: {
    savefbpaystatus(status) {
      var vm = this
      var data = {
        pageid: this.selectedBot.pageid,
        fbpay_status: status,
        access_token: this.selectedBot.page_access_token
      }
      // console.log(data)
      return new Promise((resolve, reject) => {
        api.savefbpaystatus(data, async function(error, response) {
          if (error) {
            vm.fbpayStatus = status

            return reject(error)
          } else {
            resolve(response)
          }
        })
      })
    },
    async toggleStatus() {
      this.fb_pay_dialog = false
      this.loading = true
      if (this.selectedBot) {
        this.$store.dispatch('loading')
        var oldstatus = this.fbpayStatus
        var status = this.fbpayStatus == null ? true : !this.fbpayStatus
        try {
          var response = await this.savefbpaystatus(status)
          this.$store.dispatch('loading')
          await this.$swal.fire({
            title: this.$t('Success'),
            type: 'success',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: true
          })
          this.fbpayStatus = status
        } catch (error) {
          this.fbpayStatus = oldstatus
          this.$store.dispatch('loading')
          await this.$swal.fire({
            type: 'error',
            text: this.$t('Unable to activate Meta Pay'),
            footer: `<a href="https://blog.zwiz.app/metapay-registration/" target="_blank">
                    ${this.$t('See the instruction in order to sign up for Meta Pay')}
                    </a>`
          })
        }
        await this.$store.dispatch('updateBotDetail')
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/FbpayPayment.vue